import {useEffect, useState} from "react";
import {listFieldRegistry} from "@modules/fields/api/fieldRegistryApi.js";

// Stesso sentinel di default usato dal backend (fields.controller.js#serializeField):
// i campi non ancora personalizzati restano sul blu attualmente in uso ovunque.
export const DEFAULT_FIELD_COLOR = "blue";

export async function fetchFieldColorMap()
{
	const result = await listFieldRegistry();
	const map = new Map();
	if (result?.ok !== false && Array.isArray(result?.fields))
	{
		for (const field of result.fields)
			if (field?.key)
				map.set(field.key, field.color || DEFAULT_FIELD_COLOR);
	}
	return map;
}

/**
 * Mappa key campo -> colore configurato in Impostazioni > Descrizioni AI.
 * Usata ovunque i valori di un campo tassonomia (bollino/meccanica/filtro/categoria/
 * classe/fondi) vengono mostrati come Tag, per restare coerenti col colore scelto.
 */
export function useFieldColorMap()
{
	const [colorMap, setColorMap] = useState(() => new Map());

	useEffect(() =>
	{
		let cancelled = false;
		fetchFieldColorMap().then((map) =>
		{
			if (!cancelled)
				setColorMap(map);
		});
		return () => { cancelled = true; };
	}, []);

	return colorMap;
}

export function getFieldColor(colorMap, key, fallback = DEFAULT_FIELD_COLOR)
{
	if (!colorMap || !key)
		return fallback;
	return colorMap.get(key) || fallback;
}

// I preset storici (blue/green/...) sono validi per <Tag color="..."> di antd, ma non
// tutti sono colori CSS riconosciuti dal canvas (es. Konva): "geekblue" in particolare
// non esiste come keyword CSS. Qui si converte sempre in hex per consumer non-antd.
const PRESET_COLOR_HEX = {
	blue: "#1677ff",
	green: "#52c41a",
	orange: "#fa8c16",
	purple: "#722ed1",
	cyan: "#13c2c2",
	geekblue: "#2f54eb",
	red: "#f5222d",
	gold: "#faad14",
	magenta: "#eb2f96",
	volcano: "#fa541c",
	lime: "#a0d911"
};

export function toHexColor(color, fallback = PRESET_COLOR_HEX[DEFAULT_FIELD_COLOR])
{
	if (!color)
		return fallback;
	return PRESET_COLOR_HEX[color] || color || fallback;
}
